import { useCallback } from "preact/compat";
import Modal from "~/components/modal.tsx";
import useAppDispatch from "~/hooks/use-app-dispatch.ts";
import { closeTutorial } from "./store-slice.ts";
import { useTranslator } from "@brickme/frontend-common/src/i18n/translation.tsx";

type TutorialModalProps = {
	readonly show: boolean;
};

function TutorialModal({ show }: TutorialModalProps) {
	const dispatch = useAppDispatch();
	const t = useTranslator();
	const onClose = useCallback(() => {
		dispatch(closeTutorial());
	}, [dispatch]);

	return (
		<Modal show={show} size="large">
			<div className="default-modal__tutorial-video">
				{show && (
					<iframe
						title={t("Tutorial")}
						className="default-modal__tutorial-video__frame"
						src="https://www.youtube.com/embed/fKTlwGnuZSU"
						frameBorder={0}
						allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
						allowFullScreen
					/>
				)}
			</div>
			<Modal.Actions
				actions={[{ text: t("Close"), onClick: onClose, type: "ghost" }]}
			/>
		</Modal>
	);
}

export default TutorialModal;
